<template>
    <div class="proOption">
        <div
            class="btnGroup"
            v-for="({name, values, currId}, index) in attr_list"
            :key="name"
        >
            <span>{{name}}</span>
            <el-button-group>
                <el-button
                    v-for="{label, id} in values"
                    :key="id"
                    :class="{'chosen': currId===id}"
                    @click="handleChoose(index, id)"
                >
                    <!-- <img src='../../assets/supply/prod.png' alt=''/> -->
                    {{label}}
                </el-button>
            </el-button-group>
        </div>
        <div class="amount">
            <span>单价</span>
            <span>￥{{price.toFixed(2)}}元</span>
        </div>
        <div v-if="type===1" class="amount">
            <span>数量</span>
            <!-- <span>
                <el-input-number
                    v-model="repertory===0?repertory:qty"
                    size="small"
                    controls-position="right"
                    :min="repertory===0? 0: 1"
                    :max="repertory"
                    :step="1"></el-input-number>
                件<span>库存{{repertory}}件</span>
            </span> -->
            <span>
                <el-input-number
                    v-model="qty"
                    size="small"
                    :min="0"
                    controls-position="right"
                    :step="1"></el-input-number>
                <!-- 件<span>库存{{repertory}}件</span> -->
            </span>
        </div>

        <div class="footer">
            <!-- <el-tooltip v-show="repertory===0" effect="dark" content="这个卖完了" placement="top">
                <el-button style="cursor: not-allowed" type="primary">确定</el-button>
            </el-tooltip>
            <el-button v-show="repertory!==0" type="primary" @click="addProduct" :loading="btnLoading">确定
            </el-button> -->
            <el-button  type="primary" @click="addProduct" :loading="btnLoading">确定
            </el-button>
            <el-button @click="$emit('update:visible', false)">取消</el-button>
        </div>
    </div>
</template>

<script>
    import { getPrice, addCartProducts, addorderList } from '../../stores/api';

    export default {
        //type 1:dialog, 2:popover
        props: ['type', 'list', 'visible', 'goods_id', 'getCartProducts', 'rec_id', 'qtyRaw','fang'],
        data () {
            return {
                btnLoading: false,
                price: 0,
                repertory: 1,
                qty: 1,
                attr_list: this.list || []
            };
        },
        beforeMount () {
            console.log("list",this.attr_list);
            this.getPrice();
        },
        // mounted(){
        //     this.fang()
        // },
        methods: {
            handleChoose (index, id) {
                console.log(id)
                if (this.attr_list[index].currId !== id) {
                    this.attr_list[index].currId = id;
                    this.getPrice();
                }
            },
            addProduct () {
                let order_id = localStorage.getItem('order_id');
                // localStorage.removeItem('order_id')
                this.btnLoading = true;
                const spec = this.attr_list.map(item => item.currId);
                let params = {
                    goods_id: this.goods_id,
                    number: this.type === 2 ? this.qtyRaw : this.qty,
                    parant: 0,
                    spec,
                    quick: spec.length === 0 ? 0 : 1,
                };
                if(order_id==null){
                    addCartProducts(params, this.rec_id).then(() => {
                        this.$notify.success({
                            title: '操作成功',
                            message: this.type === 1 ? '已添加到购物车' : '已修改商品参数',
                        });
                        this.attr_list="";
                        this.getCartProducts();
                        this.qty = 1;
                    }).catch((err) => {
                        this.$notify.error({
                            title: '操作失败',
                            message: err.message,
                        });
                    }).then(() => {
                        this.btnLoading = false;
                        this.$emit('update:visible', false);
                    });
                } else{
                    addorderList(spec.toString(),this.qty,this.price,order_id,this.goods_id).then(()=>{
                        this.btnLoading = false;
                        this.$emit('update:visible', false);
                        this.$notify.success({
                            title: '操作成功',
                            message:'已添加到订单列表' ,
                        });
                        this.$router.push('/OrderList/'+localStorage.getItem('order_sn'))
                    })
                }

            },
            getPrice () {
                let attr = '';
                this.attr_list.forEach(item => {
                    attr += item.currId + ',';
                });
                getPrice({id: this.goods_id, attr}).then(res => {
                    // console.log(this.goods_id)
                    console.log(res)
                    this.price = Number(res.data.result_no);
                    this.repertory = Number(res.data.product_number);
                });
            }
        },
        watch: {
            list (val) {
                this.attr_list = val || [];
                this.getPrice();
            },
        }
    };
</script>

<style lang="less" scoped>
    @import "../../default";

    .proOption {
        .btnGroup {
            display: flex;
            text-align: center;
            margin-bottom: 12px;
            & > span {
                flex: 0.4;
                line-height: 2;
                font-size: 14px;
            }
            .el-button-group {
                flex: 0.8;
                button {
                    min-width: 75px;
                    height: 30px;
                    margin-right: 8px;
                    margin-bottom: 8px;
                    padding: 0 10px;
                    background: #ffffff;
                    border-radius: 0;
                    border: 1px solid #dfe4ed;
                    font-size: 14px;
                    color: #1f2329;
                    &:hover {
                        .chosen;
                    }
                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 8px;
                        vertical-align: middle;
                    }
                }
                .chosen {
                    border-color: @orange;
                }
            }
        }
        .amount {
            display: flex;
            text-align: center;
            align-items: center;
            margin-bottom: 12px;
            & > span:nth-child(1) {
                flex: 0.4;
                line-height: 2;
            }
            & > span:nth-child(2) {
                flex: 0.8;
                color: #9ca2ad;
                text-align: left;
                /deep/ .el-input-number {
                    width: 75px;
                    .el-input-number__increase, .el-input-number__decrease {
                        width: 20px;
                    }
                    .el-input input {
                        color: @font_black;
                        padding: 0 30px 0 10px;
                        border-radius: 0;
                    }
                }
                & > span {
                    margin-left: 16px;
                }
            }
        }
        .footer {
            margin-top: 20px;
            padding-left: 150px;
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/Common/ProOptions.vue